import React from "react";
import { Link, Redirect } from "react-router-dom";

import "../../styles/_thankyou.scss";

class ThankYou extends React.Component {
  state = {
    navigate: false,
  };

  componentDidMount() {
    this.timeOut = setTimeout(() => this.setState({ navigate: true }), 40000);
  }

  componentWillUnmount() {
    clearTimeout(this.timeOut);
  }

  render() {
    if (this.state.navigate) return <Redirect to="/home" />;
    return (
      <div className="thank-you">
        <h1 className="thank-you-header">Thank you!</h1>
        <div className="thank-you-content">
          <div className="thank-you-info">
            <div className="info-message">
              <p>The lead form was successfully submitted.</p>
              <p>(This page will automatically re-direct to homepage)</p>
            </div>
            <Link to="/home">
              <button className="btn btn-default">Go Home</button>
            </Link>
          </div>
        </div>
      </div>
    );
  }
}

export default ThankYou;
